const FOCUSABLE_SELECTOR =
  'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export class FocusTrap {
  private element: HTMLElement | null = null;
  private previousFocus: HTMLElement | null = null;
  private handleKeyDown: ((e: KeyboardEvent) => void) | null = null;

  activate(element: HTMLElement): void {
    this.element = element;
    this.previousFocus = document.activeElement as HTMLElement;

    this.handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Tab') return;
      if (!this.element) return;

      const focusable = this.element.querySelectorAll(FOCUSABLE_SELECTOR);
      if (focusable.length === 0) return;

      const first = focusable[0] as HTMLElement;
      const last = focusable[focusable.length - 1] as HTMLElement;

      if (e.shiftKey) {
        if (document.activeElement === first) {
          last.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === last) {
          first.focus();
          e.preventDefault();
        }
      }
    };

    this.element.addEventListener('keydown', this.handleKeyDown);

    // Focus first focusable element
    const focusable = this.element.querySelectorAll(FOCUSABLE_SELECTOR);
    if (focusable.length > 0) {
      (focusable[0] as HTMLElement).focus();
    }
  }

  deactivate(): void {
    if (this.element && this.handleKeyDown) {
      this.element.removeEventListener('keydown', this.handleKeyDown);
    }
    if (this.previousFocus) {
      this.previousFocus.focus();
    }
    this.element = null;
    this.handleKeyDown = null;
    this.previousFocus = null;
  }
}
